import ActionTypeConstants from "helpers/ActionTypeConstants"
import ApiErrorConstants from "helpers/ApiErrorConstants"
import { URLS } from "helpers/ApiEndpointConstants"
import axios from "axios"
import Cookies from 'js-cookie';

import { store } from "./../../index";

/**
 * - authToken will not be used because auth will hapen via cookie
 * - API should be simplified - API_DATAKEY is very unnecesarry - the data
 *   object to the server should be {object: ..., action, ..., user: ..., data: { ... business data inside it ...}}
 * - When API is fixed to return errors, error handling should be fixed + redirect to login for unauth statuses
 */

/**
 * Generic API call
 */

let sessionTimer = null;

export const actionApiCall = async request => {
    const org = Cookies.get('org') || false;
    const site = Cookies.get('site') || false;

    if (sessionTimer){
        window.clearTimeout(sessionTimer);
    }
    sessionTimer = window.setTimeout(() => {
        // check if we're logged in and selected org, don't display on site select.
        if (org) {
            store.dispatch({ type: ActionTypeConstants.SHOW_SESSION_MODAL, payload: { message: "Session will expire!"} });
        } else {
            store.dispatch({ type: ActionTypeConstants.AUTH_LOGOUT });
        }
      }, 14 * 60 * 1000);

    // Request is defined per actionType, so it is required.
    if (!(request && request.actionType)) {
        return generateResponseObject(
            request,
            null,
            false,
            ApiErrorConstants.INVALID_API_REQUEST_PARAMS,
            request
        )
    }

    // The actionType must exist as a constant
    if (!ActionTypeConstants[request.actionType]) {
        return generateResponseObject(
            request,
            null,
            false,
            ApiErrorConstants.UNKNOWN_API_ACTION_TYPE,
            request
        )
    }

    // There must be an API definition for the actionType
    if (
        !(
            URLS[request.actionType] &&
            URLS[request.actionType].URL &&
            URLS[request.actionType].METHOD &&
            URLS[request.actionType].API_OBJECT &&
            URLS[request.actionType].API_ACTION
        )
    ) {
        return generateResponseObject(
            request,
            null,
            false,
            ApiErrorConstants.NO_API_DEFINITION_FOR_ACTION_TYPE,
            request
        )
    }

    // Return an error if actionType requires authentication, but no token is in request
    // if (!request.authToken && URLS[request.actionType].IS_AUTH) {
    //     return generateResponseObject(
    //         request,
    //         null,
    //         false,
    //         ApiErrorConstants.REQUIRED_API_AUTH_TOKEN_MISSING,
    //         request
    //     )
    // }

    const reqUrl = URLS[request.actionType].URL
    const reqMethod = URLS[request.actionType].METHOD
    const apiObject = URLS[request.actionType].API_OBJECT
    const apiAction = URLS[request.actionType].API_ACTION
    const reqData = request.data
    const subtask = request.subtask
    try {
        const state = await store.getState();
        const selected = state.UserOrgSiteReducer.selected;

        const reqConfig = {
            method: reqMethod,
            url: reqUrl,
            responseType: (apiAction === 'download' || apiAction === 'csv') ? "blob" : "json",
            data: {
                object: apiObject,
                action: apiAction,
                data: reqData,
                organization: (selected && selected.org) ? selected.org : org,
                site: (selected && selected.site) ? selected.site : site,
            }
        }

        //some objects allow subtypes (ie Tasks)
        if (subtask){
            reqConfig.data.subtask = subtask;
        }

        // if (authToken) {
        //   reqConfig.headers = {
        //     'Authorization': `Bearer ${authToken}`,
        //   }
        // }

        reqConfig.withCredentials = true;

        if (request.userId) {
            reqConfig.data.user = request.userId
        }

        if (request.authToken) {
            reqConfig.data.token = request.authToken
        }

        const res = await axios(reqConfig);

        if (res.data.invalid === true) {
            store.dispatch({ type: 'AUTH_LOGOUT' });
        }

        return generateResponseObject(request, res, true)

    } catch (err) {
        const errObj = {}

        if (err.response) {
            errObj.res = {
                data: err.response.data,
                status: err.response.status,
                headers: err.response.headers
            }
        } else if (err.request) {
            errObj.req = {
                readyState: err.request.readyState
            }
        }

        errObj.msg = err.message
        errObj.config = err.config

        return generateResponseObject(
            request,
            err.response ? err.response : null,
            err.response ? true : false,
            ApiErrorConstants.API_CALL_ERROR,
            errObj
        )
    }
}

/**
 * Generates response object for the request.
 *
 * @param {object} req Request object
 * @param {object} [res] Response object
 * @param {boolean} [isAfterCall] Whether a request has been dispatched to API
 * @param {object} [errType] ApiErrorConstant
 * @param {object} [errObj] Error object
 *
 * @returns {object} Response object:
 * {
 *    req: Original request
 *    res: { Original response
 *      err: { Error object to be handled by UI
 *        msg: User-facing error message
 *        devMsg: Debug message
 *        errObj: Detailed error object
 *      }
 *    }
 * }
 */
const generateResponseObject = (req, res, isAfterCall, errType, errObj) => {
    const responseObject = {
        req,
        res,
        isAfterCall
    }

    if (errType) {
        responseObject.err = {
            msg: errType.USR_MSG,
            devMsg: errType.DEV_MSG,
            errObj
        }
    }

    return responseObject
}
